module.exports = __webpack_public_path__ + "img/icon-steps-2.cd51583a.png";